<template>
  <div>
    <form
      class="furniture furniture-add"
      :class="{ 'furniture-add-loading': isWebscraping }"
      v-if="isAddingProduct || isEditingProduct"
    >
      <ProductImageCarousel
        v-if="allImageFiles.length > 0"
        :images="allImageFiles"
        :growWidth="true"
        :editable="true"
        @on-add-images="imageFileInput?.click()"
        @on-remove-image="onRemoveImage"
      />
      <button
        v-else
        class="furniture-add__image"
        type="button"
        @click="imageFileInput?.click()"
      >
        <svg
          width="60"
          height="54"
          viewBox="0 0 60 54"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M48.666 16.3333V10.9999H43.3327V5.66658H48.666V0.333252H53.9994V5.66658H59.3327V10.9999H53.9994V16.3333H48.666ZM5.99935 53.6666C4.53268 53.6666 3.27757 53.1448 2.23402 52.1012C1.18868 51.0559 0.666016 49.7999 0.666016 48.3332V16.3333C0.666016 14.8666 1.18868 13.6115 2.23402 12.5679C3.27757 11.5226 4.53268 10.9999 5.99935 10.9999H14.3993L19.3327 5.66658H35.3327V10.9999H21.666L16.7994 16.3333H5.99935V48.3332H48.666V24.3333H53.9994V48.3332C53.9994 49.7999 53.4776 51.0559 52.434 52.1012C51.3887 53.1448 50.1327 53.6666 48.666 53.6666H5.99935ZM27.3327 44.3332C30.666 44.3332 33.4998 43.167 35.834 40.8346C38.1665 38.5004 39.3327 35.6666 39.3327 32.3333C39.3327 28.9999 38.1665 26.1661 35.834 23.8319C33.4998 21.4995 30.666 20.3333 27.3327 20.3333C23.9993 20.3333 21.1656 21.4995 18.8313 23.8319C16.4989 26.1661 15.3327 28.9999 15.3327 32.3333C15.3327 35.6666 16.4989 38.5004 18.8313 40.8346C21.1656 43.167 23.9993 44.3332 27.3327 44.3332ZM27.3327 38.9999C25.466 38.9999 23.8882 38.3555 22.5993 37.0666C21.3105 35.7777 20.666 34.1999 20.666 32.3333C20.666 30.4666 21.3105 28.8888 22.5993 27.5999C23.8882 26.311 25.466 25.6666 27.3327 25.6666C29.1994 25.6666 30.7771 26.311 32.066 27.5999C33.3549 28.8888 33.9994 30.4666 33.9994 32.3333C33.9994 34.1999 33.3549 35.7777 32.066 37.0666C30.7771 38.3555 29.1994 38.9999 27.3327 38.9999Z"
            fill="currentColor"
          />
        </svg>
        <span>{{ $t("list.images_add") }}</span>
      </button>
      <input
        type="file"
        ref="imageFileInput"
        @change="onImageFilesPicked"
        hidden
        multiple
        accept="image/*"
      />
      <div class="furniture__content">
        <div class="furniture__wrapper">
          <div class="furniture__base">
            <EditableField
              v-model="form.title"
              id="title"
              fontSize="2.25rem"
              :placeholder="$t('list.product_name')"
              ref="titleInput"
            />
            <div class="furniture-add__files">
              <button
                class="furniture-add__file-btn"
                type="button"
                v-for="(file, index) in form.files"
                :key="file.name"
                @click="onRemoveFile(file, index)"
                :title="$t('list.file_delete')"
              >
                {{ file.name ?? $t("list.file_noname") }}
                <svg
                  class="furniture-add__file-icon"
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                >
                  <path
                    d="M14.875 2.75625H11.7437L11.7438 2.125L11.7437 2.12432C11.7415 1.62957 11.544 1.15571 11.1941 0.805865C10.8443 0.456017 10.3704 0.258485 9.87568 0.25625H9.875L6.125 0.256248L6.12432 0.256252C5.62957 0.258485 5.15571 0.456017 4.80586 0.805865C4.45602 1.15571 4.25849 1.62957 4.25625 2.12432V2.125V2.75625H1.125C0.960897 2.75625 0.803516 2.82144 0.687478 2.93748C0.571439 3.05352 0.50625 3.2109 0.50625 3.375C0.50625 3.5391 0.571439 3.69648 0.687478 3.81252C0.803516 3.92856 0.960897 3.99375 1.125 3.99375H1.75625V15.25C1.75625 15.5799 1.88729 15.8962 2.12054 16.1295C2.35378 16.3627 2.67014 16.4937 3 16.4937H13C13.3299 16.4937 13.6462 16.3627 13.8795 16.1295C14.1127 15.8962 14.2437 15.5799 14.2437 15.25V3.99375H14.875C15.0391 3.99375 15.1965 3.92856 15.3125 3.81252L15.2065 3.70646L15.3125 3.81252C15.4286 3.69648 15.4937 3.5391 15.4937 3.375C15.4937 3.2109 15.4286 3.05352 15.3125 2.93748L15.2065 3.04354L15.3125 2.93748C15.1965 2.82144 15.0391 2.75625 14.875 2.75625ZM5.49375 2.125C5.49375 1.95758 5.56026 1.79702 5.67864 1.67864C5.79702 1.56026 5.95758 1.49375 6.125 1.49375H9.875C10.0424 1.49375 10.203 1.56026 10.3214 1.67864L10.4274 1.57257L10.3214 1.67864C10.4397 1.79702 10.5063 1.95758 10.5063 2.125V2.75625H5.49375V2.125ZM13.0063 15.25C13.0063 15.251 13.006 15.252 13.0055 15.2529C13.0052 15.2535 13.0049 15.254 13.0044 15.2544L13.1105 15.3605L13.0044 15.2544C13.0032 15.2556 13.0017 15.2563 13 15.2563H3C2.99834 15.2563 2.99675 15.2556 2.99558 15.2544L2.88951 15.3605L2.99558 15.2544C2.99441 15.2532 2.99375 15.2517 2.99375 15.25V3.99375H13.0063V15.25ZM6.74375 12.125V7.125C6.74375 6.9609 6.67856 6.80352 6.56252 6.68748C6.44648 6.57144 6.2891 6.50625 6.125 6.50625C5.9609 6.50625 5.80352 6.57144 5.68748 6.68748C5.57144 6.80352 5.50625 6.9609 5.50625 7.125V12.125C5.50625 12.2891 5.57144 12.4465 5.68748 12.5625C5.80352 12.6786 5.9609 12.7437 6.125 12.7437C6.2891 12.7437 6.44648 12.6786 6.56252 12.5625C6.67856 12.4465 6.74375 12.2891 6.74375 12.125ZM10.4937 12.125V7.125C10.4937 6.9609 10.4286 6.80352 10.3125 6.68748C10.1965 6.57144 10.0391 6.50625 9.875 6.50625C9.7109 6.50625 9.55352 6.57144 9.43748 6.68748C9.32144 6.80352 9.25625 6.9609 9.25625 7.125V12.125C9.25625 12.2891 9.32144 12.4465 9.43748 12.5625C9.55352 12.6786 9.7109 12.7437 9.875 12.7437C10.0391 12.7437 10.1965 12.6786 10.3125 12.5625C10.4286 12.4465 10.4937 12.2891 10.4937 12.125Z"
                    fill="currentColor"
                    stroke="currentColor"
                    stroke-width="0.3"
                  />
                </svg>
              </button>
              <button
                class="furniture-add__file-btn"
                type="button"
                v-if="isEditingProduct"
                v-for="(file, index) in editFiles.filesToAdd"
                :key="file.name"
                @click="onRemoveEditFile(file, index)"
                :title="$t('list.file_delete')"
              >
                {{ file.name }}
                <svg
                  class="furniture-add__file-icon"
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                >
                  <path
                    d="M14.875 2.75625H11.7437L11.7438 2.125L11.7437 2.12432C11.7415 1.62957 11.544 1.15571 11.1941 0.805865C10.8443 0.456017 10.3704 0.258485 9.87568 0.25625H9.875L6.125 0.256248L6.12432 0.256252C5.62957 0.258485 5.15571 0.456017 4.80586 0.805865C4.45602 1.15571 4.25849 1.62957 4.25625 2.12432V2.125V2.75625H1.125C0.960897 2.75625 0.803516 2.82144 0.687478 2.93748C0.571439 3.05352 0.50625 3.2109 0.50625 3.375C0.50625 3.5391 0.571439 3.69648 0.687478 3.81252C0.803516 3.92856 0.960897 3.99375 1.125 3.99375H1.75625V15.25C1.75625 15.5799 1.88729 15.8962 2.12054 16.1295C2.35378 16.3627 2.67014 16.4937 3 16.4937H13C13.3299 16.4937 13.6462 16.3627 13.8795 16.1295C14.1127 15.8962 14.2437 15.5799 14.2437 15.25V3.99375H14.875C15.0391 3.99375 15.1965 3.92856 15.3125 3.81252L15.2065 3.70646L15.3125 3.81252C15.4286 3.69648 15.4937 3.5391 15.4937 3.375C15.4937 3.2109 15.4286 3.05352 15.3125 2.93748L15.2065 3.04354L15.3125 2.93748C15.1965 2.82144 15.0391 2.75625 14.875 2.75625ZM5.49375 2.125C5.49375 1.95758 5.56026 1.79702 5.67864 1.67864C5.79702 1.56026 5.95758 1.49375 6.125 1.49375H9.875C10.0424 1.49375 10.203 1.56026 10.3214 1.67864L10.4274 1.57257L10.3214 1.67864C10.4397 1.79702 10.5063 1.95758 10.5063 2.125V2.75625H5.49375V2.125ZM13.0063 15.25C13.0063 15.251 13.006 15.252 13.0055 15.2529C13.0052 15.2535 13.0049 15.254 13.0044 15.2544L13.1105 15.3605L13.0044 15.2544C13.0032 15.2556 13.0017 15.2563 13 15.2563H3C2.99834 15.2563 2.99675 15.2556 2.99558 15.2544L2.88951 15.3605L2.99558 15.2544C2.99441 15.2532 2.99375 15.2517 2.99375 15.25V3.99375H13.0063V15.25ZM6.74375 12.125V7.125C6.74375 6.9609 6.67856 6.80352 6.56252 6.68748C6.44648 6.57144 6.2891 6.50625 6.125 6.50625C5.9609 6.50625 5.80352 6.57144 5.68748 6.68748C5.57144 6.80352 5.50625 6.9609 5.50625 7.125V12.125C5.50625 12.2891 5.57144 12.4465 5.68748 12.5625C5.80352 12.6786 5.9609 12.7437 6.125 12.7437C6.2891 12.7437 6.44648 12.6786 6.56252 12.5625C6.67856 12.4465 6.74375 12.2891 6.74375 12.125ZM10.4937 12.125V7.125C10.4937 6.9609 10.4286 6.80352 10.3125 6.68748C10.1965 6.57144 10.0391 6.50625 9.875 6.50625C9.7109 6.50625 9.55352 6.57144 9.43748 6.68748C9.32144 6.80352 9.25625 6.9609 9.25625 7.125V12.125C9.25625 12.2891 9.32144 12.4465 9.43748 12.5625C9.55352 12.6786 9.7109 12.7437 9.875 12.7437C10.0391 12.7437 10.1965 12.6786 10.3125 12.5625C10.4286 12.4465 10.4937 12.2891 10.4937 12.125Z"
                    fill="currentColor"
                    stroke="currentColor"
                    stroke-width="0.3"
                  />
                </svg>
              </button>
              <button
                class="furniture-add__file-btn"
                type="button"
                @click="fileInput?.click()"
              >
                <svg width="12" height="14" viewBox="0 0 12 14" fill="none">
                  <path
                    d="M10.0827 11.0833H3.66602C3.34518 11.0833 3.07063 10.9691 2.84235 10.7408C2.61368 10.5122 2.49935 10.2374 2.49935 9.91659V1.74992C2.49935 1.42909 2.61368 1.15434 2.84235 0.925669C3.07063 0.697391 3.34518 0.583252 3.66602 0.583252H7.2681C7.42365 0.583252 7.57202 0.612419 7.71318 0.670752C7.85396 0.729085 7.97782 0.811724 8.08477 0.918669L10.9139 3.74784C11.0209 3.85478 11.1035 3.97864 11.1618 4.11942C11.2202 4.26059 11.2493 4.40895 11.2493 4.5645V9.91659C11.2493 10.2374 11.1352 10.5122 10.9069 10.7408C10.6783 10.9691 10.4035 11.0833 10.0827 11.0833ZM7.16602 1.74992H3.66602V9.91659H10.0827V4.66659H7.74935C7.58407 4.66659 7.44563 4.61078 7.33402 4.49917C7.22202 4.38717 7.16602 4.24853 7.16602 4.08325V1.74992ZM1.33268 13.4166C1.01185 13.4166 0.737293 13.3024 0.509016 13.0742C0.280349 12.8455 0.166016 12.5708 0.166016 12.2499V4.66659C0.166016 4.50131 0.222016 4.36267 0.334016 4.25067C0.445627 4.13906 0.584071 4.08325 0.749349 4.08325C0.914627 4.08325 1.05327 4.13906 1.16527 4.25067C1.27688 4.36267 1.33268 4.50131 1.33268 4.66659V12.2499H7.16602C7.33129 12.2499 7.46993 12.3059 7.58193 12.4179C7.69354 12.5295 7.74935 12.668 7.74935 12.8333C7.74935 12.9985 7.69354 13.137 7.58193 13.2486C7.46993 13.3606 7.33129 13.4166 7.16602 13.4166H1.33268ZM3.66602 1.74992V4.66659V1.74992V9.91659V1.74992Z"
                    fill="#8C8F94"
                  />
                </svg>
                {{ $t("list.file_add") }}
                <input
                  type="file"
                  ref="fileInput"
                  hidden
                  @change="onFilesPicked"
                  multiple
                />
              </button>
            </div>
            <div>
              <select
                class="furniture-add__status furniture__status"
                v-if="isEditingProduct && !form.isAddedFromLink && form.status"
                v-model="form.status"
              >
                <option value="ORDERED">
                  {{ $t("list.status_" + "ORDERED".toLowerCase()) }}
                </option>
                <option value="NOT_ORDERED">
                  {{ $t("list.status_" + "NOT_ORDERED".toLowerCase()) }}
                </option>
              </select>

              <EditableField
                v-model="form.producer"
                :label="$t('list.vendor')"
                id="producer"
                :placeholder="$t('list.add')"
              />
              <div class="furniture-add__date-picker">
                <VueDatePicker
                  uid="date"
                  v-model="form.completionDate"
                  placeholder="Termin realizacji"
                  :disabled="form.isAddedFromLink"
                  :title="
                    form.isAddedFromLink
                      ? 'Termin realizacji jest dostępny tylko dla produktów spoza Ewoods'
                      : 'Termin realizacji'
                  "
                  :enable-time-picker="false"
                  format="dd/MM/yyyy"
                  locale="pl-PL"
                  select-text="Zapisz"
                  cancel-text="Anuluj"
                />
              </div>
              <textarea
                class="furniture-add__description"
                v-model="form.description"
                :placeholder="$t('list.description')"
                id="description"
                @keydown="textAreaResize"
                @click="textAreaResize"
                @keyup.delete="heightClearDuringDeleteText"
              />
              <div class="furniture__favourites furniture-add__favourites">
                <EditableField
                  v-model="form.link"
                  :placeholder="$t('list.product_link_add')"
                  font-size="2rem"
                  font-color="#353535"
                  border-visible
                  id="form-link"
                  @paste="onLinkPaste"
                  :has-icon="true"
                >
                  <template v-slot:before>
                    <svg
                      width="13"
                      height="13"
                      viewBox="0 0 13 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.50841 7.4916C5.79674 7.76587 5.79674 8.21596 5.50841 8.49023C5.23414 8.7645 4.78405 8.7645 4.50978 8.49023C3.85109 7.83055 3.48113 6.93643 3.48113 6.00421C3.48113 5.07199 3.85109 4.17787 4.50978 3.51819L6.99931 1.02866C7.65899 0.369971 8.55311 7.62939e-06 9.48533 7.62939e-06C10.4176 7.62939e-06 11.3117 0.369971 11.9714 1.02866C12.63 1.68833 13 2.58245 13 3.51468C13 4.4469 12.63 5.34102 11.9714 6.00069L10.9235 7.04855C10.9305 6.47188 10.8391 5.89521 10.6422 5.34666L10.9727 5.0091C11.1699 4.81408 11.3264 4.58189 11.4332 4.32598C11.54 4.07006 11.595 3.7955 11.595 3.51819C11.595 3.24088 11.54 2.96632 11.4332 2.71041C11.3264 2.45449 11.1699 2.22231 10.9727 2.02728C10.7777 1.83013 10.5455 1.67362 10.2896 1.5668C10.0337 1.45999 9.75913 1.40499 9.48182 1.40499C9.2045 1.40499 8.92995 1.45999 8.67403 1.5668C8.41812 1.67362 8.18593 1.83013 7.99091 2.02728L5.50841 4.50979C5.31126 4.70481 5.15474 4.937 5.04793 5.19291C4.94111 5.44882 4.88611 5.72338 4.88611 6.00069C4.88611 6.27801 4.94111 6.55256 5.04793 6.80848C5.15474 7.06439 5.31126 7.29658 5.50841 7.4916ZM7.49159 4.50979C7.76586 4.23552 8.21595 4.23552 8.49022 4.50979C9.14891 5.16946 9.51887 6.06358 9.51887 6.9958C9.51887 7.92803 9.14891 8.82215 8.49022 9.48182L6.00069 11.9714C5.34101 12.63 4.44689 13 3.51467 13C2.58245 13 1.68833 12.63 1.02865 11.9714C0.369963 11.3117 0 10.4176 0 9.48534C0 8.55312 0.369963 7.659 1.02865 6.99932L2.07651 5.95147C2.06947 6.52814 2.1609 7.10481 2.35781 7.66038L2.02728 7.99092C1.83013 8.18594 1.67361 8.41813 1.5668 8.67404C1.45998 8.92995 1.40498 9.20451 1.40498 9.48182C1.40498 9.75914 1.45998 10.0337 1.5668 10.2896C1.67361 10.5455 1.83013 10.7777 2.02728 10.9727C2.2223 11.1699 2.45449 11.3264 2.7104 11.4332C2.96631 11.54 3.24087 11.595 3.51818 11.595C3.7955 11.595 4.07006 11.54 4.32597 11.4332C4.58188 11.3264 4.81407 11.1699 5.00909 10.9727L7.49159 8.49023C7.68874 8.29521 7.84526 8.06302 7.95208 7.80711C8.05889 7.55119 8.11389 7.27663 8.11389 6.99932C8.11389 6.72201 8.05889 6.44745 7.95208 6.19154C7.84526 5.93562 7.68874 5.70344 7.49159 5.50841C7.42329 5.44441 7.36885 5.36708 7.33163 5.28119C7.29441 5.19531 7.27521 5.1027 7.27521 5.0091C7.27521 4.9155 7.29441 4.82289 7.33163 4.73701C7.36885 4.65112 7.42329 4.57379 7.49159 4.50979Z"
                        fill="#353535"
                      />
                    </svg>
                  </template>
                </EditableField>
              </div>
            </div>
          </div>
          <div class="furniture__info furniture-add__info">
            <span>{{ $t("list.amount") }}</span>
            <EditableField
              v-model="form.amount"
              id="amount"
              placeholder="0"
              number
            >
            </EditableField>
            <span>{{ $t("list.price_unit") }}</span>
            <EditableField
              v-if="!form.isAddedFromLink"
              v-model="form.priceUnit"
              id="price-unit"
              placeholder="0 PLN"
              postfix=" PLN"
              decimal
            />
            <span v-else>{{ form.priceUnit }} PLN</span>

            <span>{{ $t("list.currency") }}</span>
            <select
              class="furniture-add__currency"
              v-model="form.currency"
              :disabled="form.isAddedFromLink"
            >
              <option
                v-for="curr in currencyStore.currencies"
                :key="curr.currency"
                :value="curr.currency"
              >
                {{ curr.currency }}
              </option>
            </select>
            <span>{{ $t("list.sum") }}</span>
            <span>{{ formSum }} {{ form.currency }}</span>
          </div>
        </div>
        <div class="furniture__actions">
          <button
            class="furniture__actions-button furniture-add__actions-button"
            title="Anuluj dodawanie produktu"
            type="button"
            @click="closeAddProductForm"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="11.5" stroke="#A8ACAF" />
              <path
                d="M16.143 17.5563L11.9004 13.3137L7.65775 17.5563L6.24354 16.1421L10.4862 11.8995L6.24354 7.65685L7.65775 6.24264L11.9004 10.4853L16.143 6.24264L17.5572 7.65685L13.3146 11.8995L17.5572 16.1421L16.143 17.5563Z"
                fill="#A8ACAF"
              />
            </svg>
          </button>
        </div>
      </div>
    </form>
    <button
      v-if="isEditingProduct"
      class="add-product-button add-product-button-secondary"
      type="button"
      @click="updateProduct"
      ref="editButtonRef"
    >
      <svg
        width="15"
        height="14"
        viewBox="0 0 15 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.8277 8H8.65631V14H6.59916V8H0.427734V6H6.59916V0H8.65631V6H14.8277V8Z"
          fill="currentColor"
        />
      </svg>

      {{ $t("list.save_changes") }}
    </button>
    <button
      v-if="!isEditingProduct"
      class="add-product-button"
      :class="{ 'add-product-button-secondary': isAddingProduct }"
      type="button"
      @click="addNewProduct"
      ref="addButtonRef"
    >
      <svg
        width="15"
        height="14"
        viewBox="0 0 15 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.8277 8H8.65631V14H6.59916V8H0.427734V6H6.59916V0H8.65631V6H14.8277V8Z"
          fill="currentColor"
        />
      </svg>

      {{ isAddingProduct ? $t("list.product_save") : $t("list.product_add") }}
    </button>
  </div>
</template>

<script setup>
import ApiHelper from "@/helpsers/api.helper";
import authHelper from "@/helpsers/auth.helper";
import axios from "axios";
import { ref, reactive, computed, inject, watch, nextTick } from "vue";
import EditableField from "./EditableField.vue";
import * as yup from "yup";
import ProductImageCarousel from "./ProductImageCarousel.vue";
import { useShoppingListStore } from "@/stores/shoppingList.store";
import alertHelper from "@/helpsers/alert.helper";
import { readFileAsync } from "@/helpsers/file.helper";
import { useCurrencyStore } from "@/stores/currency.store";
import VueDatePicker from "@vuepic/vue-datepicker";
import moment from "moment";

const currencyStore = useCurrencyStore();

const allImageFiles = computed(() => {
  return form.imageFiles.concat(editFiles.imageFilesToAdd);
});

const isAddingProduct = ref(false);
const isEditingProduct = ref(false);
watch(isAddingProduct, (v) => {
  store.isAddingNewProduct = v;
});
function addNewProduct() {
  if (!isAddingProduct.value) {
    const canAdd = store.canEditOrAddProduct();
    if (!canAdd) {
      return;
    }
    isAddingProduct.value = true;
    return;
  }
  onSubmit();
}
const emit = defineEmits(["close"]);
function closeAddProductForm() {
  isAddingProduct.value = false;
  isEditingProduct.value = false;
  editProductId.value = null;
  form.title = "";
  form.originalName = "";
  form.producer = "";
  form.link = "";
  form.amount = "";
  form.priceUnit = "";
  form.description = "";
  form.currency = "PLN";
  form.completionDate = null;
  form.imageFiles = [];
  form.files = [];
  prevLink = null;
  form.isAddedFromLink = false;
  form.variantId = null;
  editFiles.filesToAdd = [];
  editFiles.filesToRemove = [];
  editFiles.imageFilesToAdd = [];
  editFiles.imageFilesToRemove = [];
  form.status = null;
  emit("close");
}

const form = reactive({
  title: "",
  /** It is used to check if it added from ewoods website */
  isAddedFromLink: false,
  producer: "",
  description: "",
  link: "",
  amount: "",
  currency: "PLN",
  priceUnit: "",
  /** @type {Date | null} */
  completionDate: null,
  /** @type {{id: string; imagePath: string; file?: any; source: "local" | "external";}[]} */
  imageFiles: [],
  files: [],
  /** Fields only used when webscraping */
  originalName: "",
  variantId: null,
  status: null,
});
const formSum = computed(() => {
  const priceUnit =
    typeof form.priceUnit === "string"
      ? form.priceUnit.replace(",", ".")
      : form.priceUnit;
  const v = form.amount * priceUnit;
  if (isNaN(v)) {
    return "Błąd";
  }
  return v.toFixed(2);
});

const fileInput = ref(null);
async function onFilesPicked(event) {
  if (!isEditingProduct.value) {
    const eventFiles = event.target.files;
    const files = Array.from(eventFiles);
    form.files.push(...files);
    return;
  }
  const eventFiles = event.target.files;
  const files = Array.from(eventFiles);
  editFiles.filesToAdd.push(...files);
}

const imageFileInput = ref(null);
async function onImageFilesPicked(event) {
  const eventFiles = event.target.files;
  const files = [];
  const filePathPromises = [];
  for (const file of Object.values(eventFiles)) {
    filePathPromises.push(readFileAsync(file));
    files.push(file);
  }
  const filePaths = await Promise.all(filePathPromises);
  const imageFiles = filePaths.map((path, index) => ({
    imagePath: path,
    id: getUniqueId(),
    file: files[index],
    /** @type {'local'} */
    source: "local",
  }));
  if (!isEditingProduct.value) {
    form.imageFiles.push(...imageFiles);
    return;
  }
  editFiles.imageFilesToAdd.push(...imageFiles);
}

const urlSchema = yup.string().url();

const isWebscraping = ref(false);

let prevLink = null;

async function onLinkPaste(event) {
  const paste = (event.clipboardData || window.clipboardData).getData("text");
  // Editing does not allow updating from the link
  if (isEditingProduct.value) {
    return;
  }

  if (prevLink === paste) {
    return;
  }
  if (!paste) {
    return;
  }
  try {
    isWebscraping.value = true;
    const link = await urlSchema.validate(paste);
    prevLink = link;
    const res = await axios.get(ApiHelper.getProductWebscrapeUrl(link), {
      headers: authHelper.authHeader(),
    });
    const [data] = res.data;
    if (!data) {
      return;
    }
    form.title = data.name;
    form.originalName = data.name;
    form.priceUnit = data.price;
    form.amount = "1";
    form.variantId = data.variantId ?? null;
    // get the domain name
    form.producer = link.replace(/.+\/\/|www.|\..+/g, "");
    // data from webscraping will always be in PLN
    form.currency = "PLN";
    form.isAddedFromLink = link.includes("ewoods");
    let imagesPaths = [data.mainImage, ...data.otherImages];
    imagesPaths = imagesPaths.map((path) =>
      path.startsWith("http") ? path : "//" + path
    );
    form.imageFiles = imagesPaths.map((path) => ({
      id: getUniqueId(),
      imagePath: path,
      source: "external",
    }));
  } catch (error) {
    console.error(error);
    form.isAddedFromLink = false;
  } finally {
    isWebscraping.value = false;
  }
}

const props = defineProps({
  projectId: {},
  shoppingListId: {},
  roomId: {},
});
const store = useShoppingListStore();
async function onSubmit() {
  const data = {
    name: form.title,
    originalName: form.originalName || form.title,
    vendor: form.producer,
    description: form.description,
    amount: form.amount || 1,
    price:
      typeof form.priceUnit === "string"
        ? form.priceUnit.replace(",", ".")
        : form.priceUnit,
    currency: form.currency,
    completionDate: form.completionDate?.toISOString() ?? null,
    /** For data from webscrape send only image urls */
    imagesUrls: form.imageFiles
      .filter((image) => image.source === "external")
      .map((image) => image.imagePath),
  };
  if (form.link) {
    data.link = form.link;
  }
  if (form.variantId) {
    data.variantId = form.variantId;
  }
  const { isSuccess } = await store.addProduct({
    shoppingListId: props.shoppingListId,
    roomId: props.roomId,
    data,
    imageFilesToSend: form.imageFiles
      .filter((f) => f.source !== "external")
      .map((f) => f.file),
    filesToSend: form.files,
  });
  if (!isSuccess) {
    return;
  }
  closeAddProductForm();
}

const alert = inject("alert");
const editProductId = ref(null);
const editButtonRef = ref(null);

function showEditProduct(data) {
  if (isAddingProduct.value) {
    return alertHelper.show(
      alert,
      "Dodawanie",
      "Zakończ dodawanie nowego produktu przed edycją",
      "error"
    );
  }
  form.title = data.data.name;
  form.link = data.data.link;
  form.amount = data.data.amount;
  form.priceUnit = data.data.price;
  form.producer = data.data.vendor;
  form.description = data.data.description;
  form.completionDate = moment(data.data.completionDate).isValid()
    ? moment(data.data.completionDate).toDate()
    : null;
  form.imageFiles = data.data.shoppingListProductImages;
  form.currency = data.data.currency;
  form.files = JSON.parse(JSON.stringify(data.data.shoppingListProductFiles));
  form.isAddedFromLink = data.data?.link?.includes("ewoods") ?? false;
  form.status = data.data?.link?.includes("ewoods") ? null : data.data.status;
  editProductId.value = data.productId;
  nextTick(() => {
    isEditingProduct.value = true;
    editButtonRef.value?.focus();
  });
}

const addButtonRef = ref("");

async function addPredefinedProduct(data) {
  form.title = data.name;
  form.link = data.link;
  form.amount = data.amount;
  form.priceUnit = data.price;
  form.producer = data.vendor;
  form.description = data.description;
  form.completionDate = moment(data.completionDate).isValid()
    ? moment(data.completionDate).toDate()
    : null;
  form.imageFiles = data.shoppingListProductImages.map((img) => ({
    id: img.id,
    imagePath: img.imagePath,
    /** @type {'external'} */
    source: "external",
  }));
  form.currency = data.currency;

  const filePromises = data.shoppingListProductFiles.map(async (file) => {
    const res = await axios.get(file.filePath, { responseType: "blob" });
    const blob = res.data;
    let fileObj = new File([blob], file.name);
    return fileObj;
  });
  form.files = await Promise.all(filePromises);

  form.isAddedFromLink = data?.link?.includes("ewoods") ?? false;
  form.status = data?.link?.includes("ewoods") ? null : data.status;
  isAddingProduct.value = true;
  setTimeout(() => {
    addButtonRef.value?.focus();
  }, 200);
}

defineExpose({ showEditProduct, addPredefinedProduct });

async function updateProduct() {
  const completionDate = moment(form.completionDate).isValid()
    ? form.completionDate?.toISOString()
    : null;
  const newData = {
    name: form.title,
    vendor: form.producer,
    amount: form.amount,
    price:
      typeof form.priceUnit === "string"
        ? form.priceUnit.replace(",", ".")
        : form.priceUnit,
    link: form.link,
    description: form.description,
    currency: form.currency,
    completionDate: completionDate,
  };
  if (form.status && !form.isAddedFromLink) {
    newData.status = form.status;
  }
  const { isSuccess } = await store.editProduct({
    shoppingListId: props.shoppingListId,
    roomId: props.roomId,
    productId: editProductId.value,
    newData: newData,
    filesToAdd: editFiles.filesToAdd,
    filesToRemove: editFiles.filesToRemove,
    imageFilesToAdd: editFiles.imageFilesToAdd,
    imageFilesToRemove: editFiles.imageFilesToRemove,
  });
  if (!isSuccess) {
    return;
  }
  closeAddProductForm();
}

// Use to track added/removed files in edit form
const editFiles = reactive({
  filesToRemove: [],
  filesToAdd: [],
  imageFilesToRemove: [],
  imageFilesToAdd: [],
});
function onRemoveFile(file, index) {
  if (!isEditingProduct.value) {
    form.files = form.files.filter((_, i) => i !== index);
    return;
  }
  editFiles.filesToRemove.push(file);
  form.files = form.files.filter((f) => f.id !== file.id);
}
function onRemoveEditFile(file, index) {
  editFiles.filesToAdd = editFiles.filesToAdd.filter((_, i) => i !== index);
}

function onRemoveImage(image) {
  if (!isEditingProduct.value) {
    form.imageFiles = form.imageFiles.filter((img) => img.id !== image.id);
    return;
  }
  if (image.source === "local") {
    editFiles.imageFilesToAdd = editFiles.imageFilesToAdd.filter(
      (img) => img.id !== image.id
    );
    return;
  }
  editFiles.imageFilesToRemove.push(image);
  form.imageFiles = form.imageFiles.filter((img) => img.id !== image.id);
}

let id = 0;
function getUniqueId() {
  return id++ + "shopping-list-product-form";
}

function calcHeight(value) {
  let numberOfLineBreaks = (value.match(/\n/g) || []).length;
  // min-height + lines x line-height + padding + border
  return 80 + numberOfLineBreaks * 16 + 2 + 0;
}

function textAreaResize(el) {
  const textarea = el.target;
  textarea.style.height = calcHeight(textarea.value) + "px";
}

function heightClearDuringDeleteText(el) {
  el.target.style.height = "auto";
}

watch(isEditingProduct, (curr, old) => {
  nextTick(() => {
    const textarea = document.querySelector(".furniture-add__description");
    textarea.style.height = calcHeight(textarea.value) + "px";
  });
});
</script>

<style scoped lang="scss">
@use "@/css/shopping-list.scss";
@use "@/css/shopping-list-product.scss";
.furniture-add {
  background-color: #f6fafa;

  @media (max-width: 900px) {
    padding-top: 40px;
    flex-direction: column;
  }
  &__favourites {
    margin-top: 2rem;
    svg {
      margin-right: 0.5rem;
    }
  }
  &__info {
    * {
      color: #8c8f94;
    }
  }
  &__description {
    resize: none;
    font-weight: 500;
    font-size: 1.625rem;
    color: #8c8f94;
    font-family: "Montserrat";
    border-radius: 6px;
    border: none;
    margin: 8px 0 2px 0;
    width: 80%;
    max-width: 80ch;
    min-height: 80px;
    padding: 2px 5px;
  }
  &__date-picker {
    width: min(200px, 100%);
    margin: 10px 0;
  }
  &__files {
    padding: 1rem 0;
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
  }
  &__file-btn {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 0;
    background-color: transparent;
    border: none;
    max-width: fit-content;
    font-weight: 500;
    font-size: 1.625rem;
    cursor: pointer;
    color: #8c8f94;
    &:hover {
      opacity: 0.8;
      .furniture-add__file-icon {
        opacity: 1;
        visibility: visible;
      }
    }
  }
  &__file-icon {
    opacity: 0;
    visibility: none;
    transition: 300ms;
  }
  &__image {
    background: #ffffff;
    border: 1px solid #e4e6e4;
    border-radius: 10px;
    flex: 1 0 130px;

    @media (max-width: 900px) {
      width: 100%;
    }
    width: 130px;
    height: 130px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    font-weight: 500;
    font-size: 1.625rem;
    span {
      color: #8c8f94;
    }
    path {
      fill: #cacaca;
    }
    &:hover {
      path {
        fill: #8c8f94;
      }
    }
  }
  &-loading {
    filter: blur(2px);
  }
  &__status {
    margin: 0.7rem 0 1.5rem 0;
    border: none;
    padding: 1rem 2rem;
    font-family: inherit;
    font-size: inherit;
    cursor: inherit;
    line-height: inherit;
  }
  &__currency {
    border: none;
    font-weight: 500;
    font-size: 1.5rem;
    line-height: 2.2;
    display: flex;
    align-items: center;
    text-align: center;
    color: #3b767b;
    background: #edf3f4;
    border-radius: 6px;
    max-width: 70px;
    &:disabled {
      opacity: 0.5;
    }
  }
  &__actions-button {
    @media (max-width: 900px) {
      position: absolute;
      top: 10px;
      right: 5px;
    }
  }
}
.add-product-button {
  background-color: #eef4f4;
  border-radius: 6px;
  border: none;
  font-weight: 500;
  font-size: 1.5rem;
  color: #3b767b;
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.5rem;
  margin: 1rem 0 2px 4px;
  transition: 350ms;

  &:hover {
    cursor: pointer;
    background-color: #498388;
    color: #fff;
  }
  &-secondary {
    background: #498388;
    color: #fff;
    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
